import { Color } from './color'
import { IconName } from '../elements/Icon'

export type Intent = 'danger' | 'info' | 'success' | 'warning'

export type IntentProps = {
  backgroundColor: Color
  borderColor: Color
  color: Color
  linkColor: Color
  iconName: IconName
}

const INTENT_PROPS_MAP: Record<Intent, IntentProps> = {
  danger: {
    backgroundColor: Color.RED,
    borderColor: Color.RED,
    color: Color.WHITE,
    linkColor: Color.LIGHTEST_RED,
    iconName: 'ExclamationCircleIcon',
  },
  info: {
    backgroundColor: Color.LIGHTEST_BLUE,
    borderColor: Color.DARK_BLUE,
    color: Color.DARK_BLUE,
    linkColor: Color.DARKEST_BLUE,
    iconName: 'InformationCircleIcon',
  },
  success: {
    backgroundColor: Color.LIGHTER_GREEN,
    borderColor: Color.DARKEST_GREEN,
    color: Color.DARKEST_GREEN,
    linkColor: Color.DARK_GREEN,
    iconName: 'CheckIcon',
  },
  warning: {
    backgroundColor: Color.LIGHTER_RED,
    borderColor: Color.DARK_RED,
    color: Color.DARK_RED,
    linkColor: Color.MEDIUM_RED,
    iconName: 'ExclamationIcon',
  },
}

export const getIntentProps = (intent: Intent): IntentProps => {
  return INTENT_PROPS_MAP[intent]
}
